import { useEffect, useState } from 'react'

import { Device } from '@instabox/lockers-update-common/types'

import fetch from '../fetch'

export default function useDevices(): {
  devices: Device[]
  loading: boolean
  reload: () => void
} {
  const [devices, setDevices] = useState<Device[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  const getDevices = async (context: { shouldLoad: boolean; cancel: boolean }): Promise<void> => {
    setLoading(context.shouldLoad)

    try {
      const response = await fetch('/api/device')

      if (!response.ok) {
        throw new Error(`Unable to get packages: ${response.status} ${response.statusText}`)
      }

      const data = await response.json()

      if (context.cancel) {
        return
      }

      setDevices(data)
      setLoading(false)
    } catch {
      setLoading(false)
    }
  }

  useEffect(() => {
    const context = {
      shouldLoad: true,
      cancel: false,
    }

    getDevices(context).catch(console.error)

    return () => {
      context.cancel = true
    }
  }, [])

  return { devices, loading, reload: () => getDevices({ shouldLoad: false, cancel: false }) }
}
